import React, { useMemo, useState, useEffect } from "react";
import CustomSelect from "../CustomSelect";
import { useTranslation } from "../../hooks/useTranslation";
import useMobileScreen from "../useMobileScreen";
import { useSelector } from "react-redux";

const getPropertyName = (property, lang, preview = false) => {
    const translation = property.propertyTranslations?.find(t => t.languageIsoCode === lang);
    if (preview) {
        const limit = 15;
        const name = translation ? translation.propertyName : property.name;
        return name?.length > limit ? name?.slice(0, limit) + "..." : name;
    }
    return translation ? translation.propertyName : property.name;
};

const getCityName = (city, lang) => {
    const translation = city.translations?.find(t => t.languageIsoCode === lang);
    return translation ? translation.cityName : city.internationalName;
};

const PropertyFilter = ({ properties, selectedValue, setSelected, lang, selectedBrandName, cities }) => {
    const { t } = useTranslation();
    const isMobile = useMobileScreen();
    const chain = useSelector((state) => state.chain);

    const [propertiesLabel, setPropertyiesLabel] = useState(t("AllProperties"));

    useEffect(() => {
        const title = selectedBrandName && !selectedValue
            ? `${t("Hotels")} ${selectedBrandName}`
            : selectedValue
                ? getPropertyName(selectedValue, lang, true)
                : t("AllProperties");

        setPropertyiesLabel(title);
    }, [selectedBrandName]);

    const optionsWithAll = useMemo(() => {
        let options = []; //[{ value: "property-all", label: t("AllProperties") }];
        let propertiesByCityId = Object.groupBy(properties, p => p.cityId);
        
        cities?.map(city => {
            if(propertiesByCityId[city?.cityId]?.length > 0){   //more then 1 property in city        
                let optionsCity = propertiesByCityId[city?.cityId]?.map(p => ({ value: `property-${p.propertyId}`, label: getPropertyName(p, lang) }))
                options.push({ value: `city-${city?.cityId}`, label: getCityName(city, lang), group: true, options: optionsCity });
            }
        })

        return options;
    }, [properties, lang, cities, selectedValue, selectedBrandName, chain]);

    if (optionsWithAll.length <= 2 && !optionsWithAll.some(item => item.options?.length > 1)) return null;

    return (
        <div className="filter-section">
            <CustomSelect
                options={optionsWithAll}
                onChange={setSelected}
                selectedValue={selectedValue}
                fieldName="filterProperty"
                id="filter-property"
                placeholder={propertiesLabel}
                label={t("AllProperties")}
                className="products-filter"
                classNameButton="dropdown-toggle btn btn-primary"
                classNameList="dropdown-menu show grid-container"
                classNameGroup="grid-item"
                // renderHeader={renderMobileBrands}
                renderOption={(item) => (
                    item.disabled
                        ? <strong>{item.label}</strong>
                        : <span>{item.label}</span>
                )}
            />
        </div>
    );
};

export default PropertyFilter;
